import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

let firebaseApp;

function getFirebaseConfig() {
  return {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "",
  };
}

export function getMissingFirebaseConfigKeys() {
  const config = getFirebaseConfig();
  const requiredKeys = [
    ["REACT_APP_FIREBASE_API_KEY", config.apiKey],
    ["REACT_APP_FIREBASE_PROJECT_ID", config.projectId],
    ["REACT_APP_FIREBASE_MESSAGING_SENDER_ID", config.messagingSenderId],
    ["REACT_APP_FIREBASE_APP_ID", config.appId],
  ];

  return requiredKeys
    .filter(([, value]) => !value)
    .map(([key]) => key);
}

export function hasFirebaseConfig() {
  return getMissingFirebaseConfigKeys().length === 0;
}

export function getFirebaseApp() {
  if (!firebaseApp) {
    firebaseApp = initializeApp(getFirebaseConfig());
  }

  return firebaseApp;
}

export async function getFirebaseMessaging() {
  if (!hasFirebaseConfig()) {
    return null;
  }

  const supported = await isSupported();

  if (!supported) {
    return null;
  }

  return getMessaging(getFirebaseApp());
}
